// extracted by mini-css-extract-plugin
export default {"banner":"iUs9lxVmNlUQmloeIx5D","checkContainer":"BC5G2RheK05ChkUt9FZ2"};